import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { UPDATE_PRICE_RULE } from "../price-rule.queries";
import { parseParams } from "../../../helpers/clean-object";

import { UpdatePriceRuleInput } from "../../../__generated__/globalTypes";
import {
  UpdatePriceRuleMutation,
  UpdatePriceRuleMutationVariables,
} from "../../../__generated__/UpdatePriceRuleMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdatePriceRule = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdatePriceRuleInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdatePriceRuleMutation,
    UpdatePriceRuleMutationVariables
  >(UPDATE_PRICE_RULE, {
    refetchQueries: ["PriceRulesQuery", "PriceRuleQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updatePriceRule?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updatePriceRule?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
